import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=7fc6088a&scoped=true&"
import script from "./Message.vue?vue&type=script&lang=tsx&"
export * from "./Message.vue?vue&type=script&lang=tsx&"
import style0 from "./Message.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Message.vue?vue&type=style&index=1&id=7fc6088a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc6088a",
  null
  
)

export default component.exports